import store from '../vuex/store'
import authConfig from '../../src/dev-variable/auth-config'

const proxysPrefix = function() {
  const productName = store.state.productName
  console.log('productName -> ', productName)
  console.log('authConfig ->', authConfig)
  const isNewRouterItem = authConfig.filter(val => val.productCode === productName)
  console.log('isNewRouterItem ->', isNewRouterItem)
  if (process.env.NODE_ENV === 'development') {
    return isNewRouterItem.length > 0 ? isNewRouterItem[0].productCode : '/more_api'
  } else {
    return isNewRouterItem.length > 0 ? isNewRouterItem[0].productCode : ''
  }
}

function getRootId() {
  const productName = store.state.productName
  const isNewRouterItem = authConfig.filter(val => val.productCode === productName)[0]
  const rootId = sessionStorage.getItem('rootId') || ''
  return rootId ? `/${rootId}` : isNewRouterItem.rootId
}

export default {
  /**
   * 登陆流程接口
   */
  securityCode: proxysPrefix() + '/user/login-code', // 验证码获取
  login: proxysPrefix() + '/user/login', // 用户登陆
  getProducts: proxysPrefix() + '/products', // 根据URL获取产品products

  /**
   * 通讯录接口
   */
  addressGroup(orgId) {
    // 获取通讯录分组信息
    return proxysPrefix() + 'organizations/' + orgId + '/sub_organizations'
  },
  addressPersons(orgId) {
    // 获取分组内人员列表
    return proxysPrefix() + 'organizations/' + orgId + '/persons'
  },
  addressContact(orgId, personId) {
    // 获取联系信息
    return proxysPrefix() + 'organizations/' + orgId + '/persons/' + personId
  },
  searchPerson(orgId, searchData) {
    // 人员搜索接口
    return proxysPrefix() + 'organizations/' + orgId + '/persons/search?search=' + searchData
  },

  /**
   * 会议室管理系统
   */

  meetingRoomAuthLogin() {
    // 登录
    return proxysPrefix() + `/organizations${getRootId()}/oauth2/token`
  },
  addMeetingRoom() {
    return proxysPrefix() + `/organizations${getRootId()}/meeting-rooms`
  },
  getAllMeetingRoom() {
    return proxysPrefix() + `/organizations${getRootId()}/meeting-rooms`
  },
  meeting() {
    return proxysPrefix() + `/organizations${getRootId()}/meetings`
  },
  meetingSearchPerson() {
    return proxysPrefix() + `/organizations${getRootId()}/persons`
  },
  getmeetingRoomTags() {
    return proxysPrefix() + `/organizations${getRootId()}/tags`
  },

  /**
   * Todo list
   */

  todo() {
    return proxysPrefix() + `/organizations${getRootId()}/todos`
  },
  todoMembers(todoId) {
    return proxysPrefix() + `/organizations${getRootId()}/todos/${todoId}/members`
  },

  /**
   * get qiniu token
   */

  getQiniuToken() {
    return proxysPrefix() + `/files/tokens`
  },

  // person select
  getOrganization() {
    return proxysPrefix() + `/organizations?is_root=1`
  },
  getSubOrganization(orgId) {
    return proxysPrefix() + `/organizations/${orgId}/sub-organizations`
  },
  getSubOrganizationPersons(orgId, subOrgId) {
    return proxysPrefix() + `/organizations/${orgId}/sub-organizations/${subOrgId}/persons`
  },
  getPersons() {
    return proxysPrefix() + `/organizations${getRootId()}/persons`
  },

  // 日程安排
  itineraries() {
    return proxysPrefix() + `/organizations${getRootId()}/itineraries`
  },
  itineraryById(itineraryId) {
    return proxysPrefix() + `/organizations${getRootId()}/itineraries/${itineraryId}`
  },
  itineraryMembersById(itineraryId) {
    return proxysPrefix() + `/organizations${getRootId()}/itineraries/${itineraryId}/members`
  },

  // notice
  getNoticesList(orgId) {
    return proxysPrefix() + `/organizations${getRootId()}/notices`
  },

  notice() {
    return proxysPrefix() + `/organizations${getRootId()}/notices`
  },

  getOrganizationsByOrgId(orgId) {
    return proxysPrefix() + `/organizations/${orgId}`
  },

  getTags(orgId) {
    return proxysPrefix() + `/organizations${getRootId()}/tags?xPage=1&xLimit=1000`
  },

  getTagsPersons(tag_id) {
    return (
      proxysPrefix() + `/organizations${getRootId()}/tags/${tag_id}/persons?xPage=1&xLimit=10000`
    )
  },

  feedBack() {
    return proxysPrefix() + `/organizations${getRootId()}/feedbacks`
  },

  // 芙蓉区纪委上报系统
  report() {
    return proxysPrefix() + `/report`
  },

  // 请假系统
  getRoles(product_code) {
    return proxysPrefix() + `/organizations${getRootId()}/mini-programs/${product_code}/roles`
  },
  getRolePersons(product_code, role_code) {
    return (
      proxysPrefix() +
      `/organizations${getRootId()}/mini-programs/${product_code}/roles/${role_code}/persons`
    )
  },
  leaveRequests(type) {
    return proxysPrefix() + `/organizations${getRootId()}/leave-requests?type=${type}`
  },
  leaveRequestById(id) {
    return proxysPrefix() + `/organizations${getRootId()}/leave-requests/${id}`
  },
  leaveRequestApproval(id) {
    return proxysPrefix() + `/organizations${getRootId()}/leave-requests/${id}/approval`
  },
  leaveRequestComplete(id) {
    return proxysPrefix() + `/organizations${getRootId()}/leave-requests/${id}/complete`
  }
}



// WEBPACK FOOTER //
// ./src/tools/api.js